import { NetworkCriteriaType } from 'components/common/types/DirectSalesNetworks.types';
import {
  DirectSalesNetworkRangeSet,
  DirectSalesProductTemplateNetworkFilter,
  ProductTemplateRulesResponse,
} from 'components/common/types/DirectSalesProductTemplate.types';
import { DEFAULT_REQUEST_FORMAT_CRITERIA } from 'consts/targetCriteria';
import { SelectionPermission } from 'store/productManagement/reducer.types';

const { greenTolerance, orangeTolerance, priority } = DEFAULT_REQUEST_FORMAT_CRITERIA;

export const transformNetworks = (
  rule: ProductTemplateRulesResponse,
  selectionPermission: SelectionPermission,
): { selectionPermission: SelectionPermission; value?: NetworkCriteriaType[] } | undefined => {
  const { behaviour } = rule;

  if (behaviour === 'RANGE') {
    const rangeSet = rule.rangeSet as DirectSalesNetworkRangeSet;

    return {
      selectionPermission,
      value: rangeSet.map(
        ({
          networkName,
          networkId,
          min,
          max,
          defaultGreenTolerance,
          defaultOrangeTolerance,
          defaultPriority,
          default: defaultValue,
        }) => ({
          code: networkId,
          name: networkName,
          minValue: min ?? undefined,
          maxValue: max ?? undefined,
          defaultValue: defaultValue ?? undefined,
          greenTolerance: (defaultGreenTolerance ?? greenTolerance) * 100,
          orangeTolerance: (defaultOrangeTolerance ?? orangeTolerance) * 100,
          priority: { code: String(defaultPriority ?? priority), name: String(defaultPriority ?? priority) },
          target: '',
        }),
      ),
    };
  }

  if (behaviour === 'FIXED') {
    const fixedSet = rule.fixedSet as DirectSalesProductTemplateNetworkFilter[];

    return {
      selectionPermission,
      value: fixedSet.map(({ networkId, defaultGreenTolerance, defaultOrangeTolerance, defaultPriority, target }) => ({
        code: networkId,
        name: networkId,
        greenTolerance: (defaultGreenTolerance ?? greenTolerance) * 100,
        orangeTolerance: (defaultOrangeTolerance ?? orangeTolerance) * 100,
        priority: { code: String(defaultPriority ?? priority), name: String(defaultPriority ?? priority) },
        target: String(target),
      })),
    };
  }

  return { selectionPermission };
};
